/**
 * Hook unificado para acceder al usuario autenticado.
 * Lee del AuthContext que es provisto por el provider activo
 * (MsalAuthBridge o LocalAuthBridge segun VITE_BACKEND).
 */

import { createContext, useContext } from "react";
import type { Role } from "@constants/roles";

export interface AuthUser {
  email: string;
  name: string;
  role: Role | null;
  tenantId: string;
}

export interface AuthState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthBridge provider");
  return ctx;
}
